import Logo from "../../components/Logo";
import StepOne from "./Steps/StepOne.js";
import StepTwo from "./Steps/StepTwo.js";
import Success from "./Steps/Success.js";
import { useState } from "react";
import { useSystem } from "../../hooks/use-system";
import LanguageSelector from "../../components/LanguageSelector";
import { defaultLanguage } from "../../constants/languages";
import { Progress } from "../../components/UI/progress";
import { CircularProgress } from "../../components/UI/CircularProgress";

function DownloadGenericOne() {
  const { config, language } = useSystem();
  const [registerStep, setRegisterStep] = useState(0);
  return (
    <>
      {registerStep === 2 ? (
        <div className="download-generic-one min-h-screen bg-center bg-no-repeat bg-cover relative flex flex-col">
          <Success config={config} />
        </div>
      ) : (
        <div
          className="download-generic-one flex flex-col-reverse sm:flex-row"
          style={{
            // backgroundImage: `url(${config.background_image})`,
            backgroundColor: config.background_color,
            color: config.text_color,
            fontFamily: config.font_family,
          }}
        >
          <div className="md:w-1/2 bg-blue-500 lg:min-h-screen sm:min-h-0 justify-center items-center relative hidden sm:flex">
            <img
              src={config.background_image}
              className="max-w-full h-auto w-[80%]"
              alt="Featured"
            />
          </div>
          <div className="md:w-1/2 flex flex-col justify-center items-start px-4 md:px-[120px] bg-white ">
            <div className="flex items-center justify-between w-full lg:mt-0 mt-10">
              <div className="w-1/3 flex justify-center items-center"></div>
              <div className="w-1/3 flex justify-center items-center">
                {config.logo_url && !config.logo_under_button && (
                  <img
                    src={config.logo_url}
                    alt={"Logo"}
                    id="Logo"
                    className={`${
                      config.logo_size === "Small" ? " max-w-[200px]" : ""
                    }`}
                  />
                )}
              </div>
              <div className="w-1/3 flex justify-center items-center">
                <LanguageSelector
                  supportedLanguages={config.supported_languages}
                />
              </div>
            </div>

            <div className="flex flex-col items-center justify-center max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="">
                <h2
                  className="text-center font-bold text-xl md:text-3xl leading-snug mb-4"
                  style={{
                    color: config.titles_color || "#000",
                  }}
                >
                  {config.texts?.[language || defaultLanguage]?.[registerStep]
                    ?.title || ""}
                </h2>
              </div>
              <div className="flex flex-col   gap-5">
                <div className="flex-1">
                  <p
                    className="text-[12px] sm:text-sm font-semibold md:text-nowrap text-left"
                    style={{
                      color: config.text_color || "#000",
                    }}
                  >
                    {
                      config.texts?.[language || defaultLanguage]?.[
                        registerStep
                      ]?.step_one_text
                    }{" "}
                    {registerStep === 0 ? "1" : "2"} / 2
                  </p>
                  <div className="w-full flex md:flex-col lg:flex-row md:justify-center items-center gap-8 mx-auto">
                    <div className="w-full flex flex-col gap-2 justify-center items-start">
                      {/* <p className="text-[12px] sm:text-sm font-semibold md:text-nowrap">
                        Step {registerStep === 0 ? "1" : "2"} / 2
                      </p> */}
                      <Progress
                        className="w-full h-1"
                        value={registerStep === 0 ? 20 : 100}
                      />
                    </div>
                    <div className="w-full flex flex-col gap-2 justify-center items-start">
                      {/* <p className="text-[12px] sm:text-sm font-semibold md:text-nowrap">
                        Step 2 {registerStep === 1 ? ": Verify Number" : ""}
                      </p> */}
                      <Progress
                        className="w-full h-1"
                        value={registerStep === 0 ? 0 : 100}
                      />
                    </div>
                  </div>
                  <div className="w-[100%] flex justify-center items-center mx-auto mt-4">
                    <CircularProgress value={100} />
                  </div>
                </div>
                <div className="flex-1">
                  {config.texts?.[language || defaultLanguage]?.[registerStep]
                    ?.sec_title && (
                    <div className="w-full flex justify-center items-center lg:mt-4">
                      <p
                        className="text-md md:text-lg font-bold"
                        style={{
                          color: config.titles_color || "#000",
                        }}
                      >
                        {
                          config.texts?.[language || defaultLanguage]?.[
                            registerStep
                          ]?.sec_title
                        }
                      </p>
                    </div>
                  )}

                  {registerStep === 0 ? (
                    <StepOne
                      setStep={setRegisterStep}
                      config={config}
                      language={language}
                    />
                  ) : registerStep === 1 ? (
                    <StepTwo
                      setStep={setRegisterStep}
                      config={config}
                      language={language}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            {config.logo_url && config.logo_under_button && (
              <Logo
                logo_url={config.logo_url}
                logo_position={config.logo_position}
                logo_size={config.logo_size}
                classes="bottom"
              />
            )}
            <div className="mt-5 mb-1 text-center w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
              <div
                className="font-medium text-[9px] text-justify leading-[12px] flex flex-col gap-2 w-full"
                dangerouslySetInnerHTML={{
                  __html:
                    config.texts?.[language || defaultLanguage]?.[registerStep]
                      ?.paragraph_under_button || "",
                }}
              ></div>
              <div className="flex flex-col items-center">
                {config.flow_icon && (
                  <div className="w-full my-1">
                    <img
                      src={config.flow_icon}
                      alt="Flow Icon"
                      className="mx-auto"
                    />
                  </div>
                )}
                <div className="w-full flex flex-wrap justify-center text-sm text-center space-x-4">
                  <a href={config.terms_url} className="text-gray-700">
                    {config.terms_text}
                  </a>

                  {config.policy_url && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.policy_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {config.policy_text}
                      </a>
                    </>
                  )}

                  {config.about_text && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.about_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {config.about_text}
                      </a>
                    </>
                  )}

                  {config.disclaimer_text && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.disclaimer_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {config.disclaimer_text}
                      </a>
                    </>
                  )}

                  {config.contact_us_text && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.contact_us_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {config.contact_us_text}
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DownloadGenericOne;
